import React, {Component} from "react";

import {
    ControlOutlined,
    DesktopOutlined,
    LogoutOutlined,
    RiseOutlined,
    SearchOutlined,
    UserOutlined,
} from '@ant-design/icons';

import {AutoComplete, Input, Layout, Menu, Modal} from 'antd';
import {Link, withRouter} from "react-router-dom";
import {folderGetByLevelByUser} from "../requests/Folder";
import {connect} from "react-redux";
import {updateFolder} from "../../action/action";
import {userChartGetAllActive} from "../requests/UserChart";
import {AppContext} from "../libs/ContextLibs";
import {Auth} from "aws-amplify";

const {Option} = AutoComplete;
const {Sider} = Layout;
const {SubMenu} = Menu;

class AntSidebar extends Component {

    static contextType = AppContext;

    map = [];

    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            selectedKeys: [],
            visible: false,
            map: this.map,
            dashboardFolders: [],
            user: {},
            isUserNameOverride: false
        };
        this.getDashboardList = this.getDashboardList.bind(this);
        this.dataToTree = this.dataToTree.bind(this);
        this.printFolder = this.printFolder.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.getData = this.getData.bind(this);
        this.logout = this.logout.bind(this);
    }


    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    async getData() {
        this.getAllDashboards().then(this.getDashboardList());
    }

    async logout() {
        this.props.logout();
    };

    onCollapse = collapsed => {
        this.setState({collapsed});
    };

    async getAllDashboards() {
        let map = [];
        userChartGetAllActive((this.context.isUserNameOverride && this.context.userNameOverride) ? this.context.userNameOverride : this.state.user.username, (r) => {
            r.data.map((d) => {
                return map.push({"id": d._id, "value": d.title});
            });
            this.setState({map: map});
        });
    }

    async getDashboardList() {
        folderGetByLevelByUser((this.context.isUserNameOverride && this.context.userNameOverride) ? this.context.userNameOverride : this.state.user.username, 0, (response) => {
            this.setState({dashboardFolders: response.data});
            this.props.updateFolder(response.data);
        });
    }

    componentDidMount() {
        this.setState({isUserNameOverride: this.context.isUserNameOverride});
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        let selected = window.location.pathname.split('/').filter(v => v !== 'dashboard' && v !== '');
        if (this.state.selectedKeys[0] !== selected[0]) {
            this.setState({selectedKeys: selected});
        }
        if ((this.props.isAuthenticated !== prevProps.isAuthenticated) && this.props.isAuthenticated) {
            this.setState({user: await Auth.currentUserInfo()});
            if (this.state.map.length === 0) {
                this.getAllDashboards().then(() => this.getDashboardList());
            }
        } else if (this.context.isUserNameOverride !== prevState.isUserNameOverride) {
            console.log('Viewing as ' + this.context.userNameOverride);
            this.getAllDashboards().then(() => this.getDashboardList());
            this.setState({isUserNameOverride: this.context.isUserNameOverride});
        } else {
            if (!this.props.isAuthenticated) {
                if (this.state.dashboardFolders.length !== 0) this.setState({dashboardFolders: []});
                if (this.state.map.length !== 0) this.setState({map: []});
            }
        }
    }

    printFolder(element, fn) {
        let b = null;
        const a = element.charts.map((chart) => {
            return (
                <Menu.Item key={chart._id}>
                    <Link to={"/dashboard/" + chart._id}>
                        <RiseOutlined/> {chart.title}</Link>
                </Menu.Item>
            );
        });
        if (element.children !== undefined && element.children.length > 0) {
            b = fn(element.children);
        }
        return [a, b];
    }

    dataToTree(data) {
        return data.filter((element) => {
            return !(element.children && element.charts && element.charts.length === 0 && element.children.length === 0);
        }).map((element) => {
            return (
                <SubMenu key={element._id} title={<span><DesktopOutlined/><span>{element.name}</span></span>}>
                    {this.printFolder(element, this.dataToTree)}
                </SubMenu>
            );
        });
    }

    render() {
        const searchMenu = (this.props.isAuthenticated) ? (
            <Menu.Item key="search" onClick={this.showModal}>
                <SearchOutlined/> <span>Search Dashboards</span>
            </Menu.Item>
        ) : null;

        const dashboardsMenu = (this.props.isAuthenticated) ? this.dataToTree(this.props.folderList || []) : null;

        const userMenu = (this.props.isAuthenticated) ? (
            <SubMenu key="user-preferences-submenu"
                     title={<span><UserOutlined/><span>{this.state.user.username}</span></span>}>
                <Menu.Item key="user-preferences">
                    <Link to={"/user-preferences"}><ControlOutlined/> User Preferences</Link>
                </Menu.Item>
                <Menu.Item key="logout" onClick={this.logout}><LogoutOutlined/> Logout</Menu.Item>
            </SubMenu>
        ) : null;

        let result = Array.from(new Set(this.state.map.map(s => s.id)))
            .map((id => {
                return {
                    id: id,
                    value: this.state.map.find(s => s.id === id).value
                };
            }));

        const options = result
            .map(d => (
                <Option key={d.id} value={d.value}>
                    {d.value}
                </Option>
            ));

        return (

            <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
                <div className="logo" style={{height: 32, margin: 16}}>
                    <Link to={"/"}>
                        {this.state.collapsed ?
                            <img src="/NIQ-logo-bright-blue.svg" style={{marginLeft: 5}} alt="NielsenIQ"
                                 height="20px"/> :
                            <img src="/niq-lg-rgb-pos.png" alt="NielsenIQ" height="30px"/>}
                    </Link>
                </div>
                <Menu theme="light" defaultSelectedKeys={['1']} selectedKeys={this.state.selectedKeys}
                      mode="inline">

                    {searchMenu}

                    {dashboardsMenu}

                    {userMenu}

                </Menu>
                <Modal
                    title="Find and go to Dashboard"
                    visible={this.state.visible}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <div style={{textAlign: 'center'}}>
                        <div className="certain-category-search-wrapper">
                            <AutoComplete
                                allowClear={true}
                                className="certain-category-search"
                                dropdownClassName="certain-category-search-dropdown"
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{width: 300}}
                                style={{width: '100%'}}
                                options={this.state.map}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                                onSelect={(val, option) => {
                                    this.props.history.push('/dashboard/' + option.id);
                                    this.handleCancel();
                                }}
                            >
                                <Input size="large" placeholder="Type dashboard name" prefix={<SearchOutlined className="certain-category-icon"/>}/>
                            </AutoComplete>
                        </div>
                    </div>

                </Modal>
            </Sider>
        );
    }
}

function mapStateToProps(state) {
    return {
        folderList: state.Reducer.folderList,
    };
}

export default withRouter(connect(mapStateToProps, {updateFolder})(AntSidebar));